module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0e92716afebebbcf027802e341220ca0.png";